import ActionTypes from '../constants/ActionTypes';

const initialState = {
  isFetching: false,
  didInvalidate: false,
  items: [],
  // totalRows: 0,
  manufacturers: [],
  models: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_PC_SPECS:
      return {
        ...state,
        isFetching: true,
        didInvalidate: false
      }

    case ActionTypes.RECEIVE_PC_SPECS:
      return {
        ...state,
        isFetching: false,
        didInvalidate: false,
        items: action.items,
        totalRows: action.items.DataCount,
        lastUpdated: action.receivedAt
      }
    
    case ActionTypes.TOTALROWS_PC_SPECS:
        return {
          ...state,
          totalRows: action.totalRows
        }

    case ActionTypes.REQUEST_MANUFACTURER:
      return {
        ...state,
      }

    case ActionTypes.RECEIVE_MANUFACTURER:
      return {
        ...state,
        manufacturers: action.items,
      }

    case ActionTypes.REQUEST_MODEL:
      return {
        ...state,
      }

    case ActionTypes.RECEIVE_MODEL:
      return {
        ...state,
        models: action.items,
      }

    // case ActionTypes.REQUEST_APPNAME:
    //   return {
    //     ...state,
    //   }
                      
    // case ActionTypes.RECEIVE_APPNAME:
    //   return {
    //     ...state,
    //     userNames: action.userNames,
    //     hpa27Names: action.hpa27Names,
    //     pcNames: action.pcNames,
    //     lastUpdated: action.receivedAt
    //   };
    
    default:
      return state
  }
}